/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionIssuerDuplicateMatch,
  RemoteSessionIssuerDuplicateMatch$inboundSchema,
} from "./remotesessionissuerduplicatematch.js";

/**
 * Existing remote_session_issuers that already describe an upstream issuer URL. Advisory: a non-empty result never blocks a create or an update.
 */
export type RemoteSessionIssuerDuplicatePreflight = {
  /**
   * The matching issuers in resolution order: project-specific first, then organization-level, then platform-level, and oldest first within a tier. The first entry is therefore the issuer this caller would resolve the URL to today. Empty when nothing describes the URL yet, and empty when the supplied URL is not a usable issuer identifier. Truncated to a fixed cap, since a warning only has to establish that duplicates exist and name a few.
   */
  matches: Array<RemoteSessionIssuerDuplicateMatch>;
};

/** @internal */
export const RemoteSessionIssuerDuplicatePreflight$inboundSchema: z.ZodMiniType<
  RemoteSessionIssuerDuplicatePreflight,
  unknown
> = z.object({
  matches: z.array(RemoteSessionIssuerDuplicateMatch$inboundSchema),
});

export function remoteSessionIssuerDuplicatePreflightFromJSON(
  jsonString: string,
): SafeParseResult<RemoteSessionIssuerDuplicatePreflight, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      RemoteSessionIssuerDuplicatePreflight$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteSessionIssuerDuplicatePreflight' from JSON`,
  );
}
